// extracted by mini-css-extract-plugin
export var body1 = "Typography-module__body1___b9Zg1";
export var body2 = "Typography-module__body2___zGGKY";
export var body3 = "Typography-module__body3___NgedC";
export var caption = "Typography-module__caption___vI_wV";
export var headline1 = "Typography-module__headline1___f74yc";
export var headline2 = "Typography-module__headline2___OQ3rc";
export var subhead2 = "Typography-module__subhead2___RiOmn";
export var title1 = "Typography-module__title1___jmGVm";
export var title2 = "Typography-module__title2___lFoRb";
export var title3 = "Typography-module__title3___wEnZi";
export var xltitle = "Typography-module__xltitle___LVIVV";
export var xxxltitle = "Typography-module__xxxltitle___AT5Lk";
export var mb8 = "Typography-module__mb8___hMCnK";
export var mb12 = "Typography-module__mb12___eflSZ";
export var mb16 = "Typography-module__mb16___yv1Zf";
export var mb24 = "Typography-module__mb24___cn7Th";
export var mb48 = "Typography-module__mb48___GZRhU";
export var mt2Xl = "Typography-module__mt2xl____f1he";
export var green = "Typography-module__green___nbzQU";
export var gray = "Typography-module__gray___bR2uw";
export var error = "Typography-module__error___Yg8ag";